import React, { PropsWithChildren } from 'react';
import { makeStyles } from '@material-ui/core';
import ExtensionIcon from '@material-ui/icons/Extension';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import AssessmentIcon from '@material-ui/icons/Assessment';
import LocalOfferIcon from '@material-ui/icons/LocalOffer';
import FlagIcon from '@material-ui/icons/Flag';
import LogoFull from './LogoFull';
import LogoIcon from './LogoIcon';
import { PermissionAwareSidebarItem } from './PermissionAwareSidebarItem';
import { getAllowedUsers } from './permissions';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <LogoFull /> : <LogoIcon />}
      </Link>
    </div>
  );
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        {/* Global nav, not org-specific */}
        {/* <SidebarItem icon={HomeIcon} to="catalog" text="Home" />*/}
        {/* <MyGroupsSidebarItem*/}
        {/*  singularTitle="My Group"*/}
        {/*  pluralTitle="My Groups"*/}
        {/*  icon={GroupIcon}*/}
        {/*/ >*/}
        {/* <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" />*/}
        <PermissionAwareSidebarItem 
          icon={AccountTreeIcon} 
          to="tonkean-circleci-plugin" 
          text="Pipelines" 
        />
        <PermissionAwareSidebarItem 
          icon={ExtensionIcon} 
          to="tonkean-versions" 
          text="Versions" 
        />
        <PermissionAwareSidebarItem
          icon={LocalOfferIcon}
          to="tonkean-releases"
          text="Release status"
        />
        <PermissionAwareSidebarItem
          icon={FlagIcon}
          to="feature-flag-rollout"
          text="Feature flag rollout"
        />
        <PermissionAwareSidebarItem 
          icon={AssessmentIcon} 
          to="tonkean-reports" 
          text="Reports" 
          allowedUsers={getAllowedUsers('reports')}
        />
        {/* <SidebarItem icon={LibraryBooks} to="docs" text="Docs" />*/}
        {/* <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />*/}
        {/* <SidebarItem icon={ExtensionIcon} to="automations" text="Automations" /> */}
        {/* End global nav */}
        <SidebarDivider />
        <SidebarScrollWrapper>
          {/* Items in this group will be scrollable if they run out of space */}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);
